import MDinput from '@/components/MDinput';
import { validatorRequire } from '@/utils/validators';
import Select from '@/components/DSE/Select';

export function getFormDefinition(vue) {
  return {
    countryID: {
      type: Select,
      defaultValue: null,
      props: {
        caption: 'transportRoute.countryCode',
        valueField: 'id',
        labelField: 'name',
        loading: vue.$store.getters['country/isLoading'],
        options: vue.$store.getters['country/loadedItems']
      }
    },
    postalCodeFrom: {
      type: MDinput,
      props: {
        caption: 'transportRoute.postalCodeFrom',
        maxlength: 7,
        required: true
      },
      rules: [{ validator: validatorRequire }]
    },
    postalCodeTo: {
      type: MDinput,
      props: {
        caption: 'transportRoute.postalCodeTo',
        maxlength: 7,
        required: true
      },
      rules: [{ validator: validatorRequire }]
    },
    code: {
      type: MDinput,
      props: {
        caption: 'transportRoute.code',
        maxlength: 4,
        required: true
      },
      rules: [{ validator: validatorRequire }]
    }
  };
}

export default getFormDefinition;

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return {
    ...item
  };
}
